import React from 'react';
import { Text } from '@user-portal/wikr-components';

import { Button } from './styled';

const OverlineButton = ({
    onClick,
    mb,
    dataLocator,
    children,
}: {
    onClick: () => void;
    mb?: string | number;
    dataLocator?: string;
    children?: React.ReactNode;
}) => (
    <Button onClick={onClick} mb={mb} data-locator={dataLocator}>
        <Text type="overline">{children}</Text>
    </Button>
);

export default OverlineButton;
